import React, { useState, useEffect, ReactNode } from 'react'
import useMicrofiche from './useMicrofiche'
import styles from './Microfiche.module.scss'

interface MicroficheProps {
  children: ReactNode // Accepts children (HiddenButton components)
}

const Microfiche: React.FC<MicroficheProps> = ({ children }) => {
  const { images, loading, zoom, handleContainerClick } = useMicrofiche({
    showImagesWithDelay: false,
  })
  const { isZoomed, zoomOrigin, delayPassed } = zoom

  return (
    <div
      className={`${styles.microficheRoot} ${isZoomed ? styles.zoomed : ''}`}
      style={{
        transformOrigin: `${zoomOrigin.x}% ${zoomOrigin.y}%`, // Set zoom origin dynamically
      }}
      onClick={handleContainerClick} // Toggle zoom for the whole container
    >
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div className={styles.microficheImages}>
          {images.map((imageSrc, index) => (
            <img
              key={index}
              src={imageSrc}
              alt={`Image ${index + 1}`}
              className={styles.image}
            />
          ))}
        </div>
      )}

      {/* Render hidden buttons only when zoomed in and after delay */}
      {delayPassed &&
        React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {})
          }
          return null
        })}
    </div>
  )
}

export default Microfiche
